import {axios, API, SendRequest} from '@/imports-files/pages/clients/jobs/scorecards';

export class ScoreCard extends SendRequest {
  
  // async getCompetencies(client_auth_cookies, jobId) {
  //   try {
  //     const result = await axios({
  //       method: 'get',
  //       url: API.client.jobs.GET_JOB.replace('$job_id', jobId),
  //       headers: {cookie: `Authorization=${client_auth_cookies}`},
  //       params: {},
  //     });
  //     return result.data;
  //     // const hash = {
  //     //   success: "Yes",
  //     //   id: "1",
  //     //   job_competency_names: [
  //     //     "Leadership",
  //     //     "Individuality",
  //     //     "Organisational skills"
  //     //   ]
  //     // }
  //     // return hash;
  //   } catch (error) {
  //     return error;
  //   }
  // }

  async getCompetencies(jobId) 
  {
    try {
      const result = await axios.get( API.client.jobs.GET_JOB.replace('$job_id', jobId),
        {
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }



  async getCompetencyByName(params) {
    try {
      const result = await axios.get( API.client.jobs.GET_COMPETENCIES_LIST,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async addCompetencies(params, jobId)
  {
    try {
      const result = await axios.post(API.client.jobs.ADD_COMPETENCIES.replace('$job_id', jobId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
}